export default __webpack_public_path__ + "static/media/Logo White.99b91fa4.svg";